module.exports = __webpack_public_path__ + "static/media/toast-icon_SUCCESS_24px.0a956c3f.svg";